<section id="card-title" class="ss-style-top">
    <div id="carte" class="row logo-d">
        <div class="col-md-12">
            <span>La carte</span>
        </div>
    </div>
</section>
<div id="orders-modes" class="start-order-module" #ordertypebar>
    <div class="orderTypes">
        <div class="promo2" *ngIf="discount>0">
            <div class="d-flex">
                <img src="assets/images/megaphone.svg" alt="promo" width="30px">
                <p class="text-center">
                    Réduction<b> {{discount}} %</b> à partir de <b>{{discountFrom}} €</b> d'achats
                </p>
            </div>
        </div>
        <button *ngFor="let type of orderTypes;let i=index" (click)="changeMode(type.id)"
            [class.active]="orderType==type.id" class="button" [class.delivery]="type.id==1" [class.pickup]="type.id==3"
            [class.onspot]="type.id==2">
            <img src="assets/images/icons/{{type.id}}.png" alt="{{type.label}}" title="{{type.label}}">
            <span>{{type.label}}</span>
        </button>
    </div>
</div>
<div class="container-fluid bag">
    <div class="mp-48">
        <div #menufixed id="menufixed">
            <div id="tuckedMenu">
                <ul class="pure-menu-list list-group" id="menu">
                    <!-- <li class="pure-menu-item">
                        <a href="javascript:void(0)" (click)="dropdown=!dropdown"
                            class="pure-menu-link nav-link scrollTo">
                            <img class="img" src="assets/images/menus.png" alt="menus">
                            <p>
                                Menus
                            </p>
                        </a>
                    </li>
                    <li class="pure-menu-item dropdown-list" [class.on]="dropdown">
                        <ul>
                            <li class="pure-menu-item" *ngFor="let mc of menucategories;let i=index">
                                <a href="javascript:void(0)" class="pure-menu-link nav-link scrollTo"
                                    [class.activeTab]="menuCategoryActive==i" (click)="menu = true;getMenus(i);">
                                    <img class="img" [src]="mc.avatar|absolutePath :'families'" [alt]="mc.name">
                                    <p>{{mc.name | uppercase}}</p>
                                </a>
                            </li>
                        </ul>
                    </li> -->
                    <li class="pure-menu-item" *ngFor="let mc of menucategories;let i=index">
                        <a href="javascript:void(0)" class="pure-menu-link nav-link scrollTo"
                            [class.activeTab]="menuCategoryActive==i" (click)="menu = true;getMenus(i);">
                            <img class="img" [src]="mc.avatar|absolutePath :'families'" [alt]="mc.name">
                            <p>{{mc.name | uppercase}}</p>
                        </a>
                    </li>
                    <li class="pure-menu-item" *ngFor="let family of families;let i=index">
                        <a href="javascript:void(0)" [class.activeTab]="familyActive==i"
                            (click)="menu = false;getProducts(i);" class="pure-menu-link nav-link scrollTo">
                            <img class="img" [src]="family.avatar|absolutePath :'families'" [alt]="family.label">
                            <p>{{family.label | uppercase}}</p>
                        </a>
                    </li>
                </ul>
            </div>
            <span id="panLeft" (mouseleave)="stopScrolling()" (mouseenter)="startScrollingEvent(-1)"
                class="panner bounce-left"><i></i>
            </span>
            <span id="panRight" (mouseleave)="stopScrolling()" (mouseenter)="startScrollingEvent(1)"
                class="panner bounce-right"><i></i>
            </span>
        </div>
        <div *ngIf="loader" id="loadingPage"></div>
        <div *ngIf="!loader" class="products container-fluid" [@fadeAnimation]="products?.length || menus?.length">
            <div class="row">
                <div *ngIf="!menu" class="d-g">
                    <div *ngFor="let product of products;let i=index" class="col-md-4 col-sm-4 carte-products scrollbar"
                        [class.newHeight]="siteClose">
                        <div class="col-container">
                            <div class="item ical">
                                <product id="product{{product.id}}" (OnPersonalize)="PersonalizeModal(i)"
                                    (OnAdd)="addElementToBasket(i)" [product]="product"></product>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="menu || menuCategoryActive == -1" class="d-g">
                    <div *ngFor="let menu of menus;let i=index" class="col-md-4 col-sm-4 carte-products scrollbar"
                        [class.newHeight]="siteClose">
                        <div class="col-container">
                            <div class="item">
                                <menu-card (OnAdd)="OpenMenuModal(i)" [menu]="menu"></menu-card>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="alert alert-dark nocontent" role="alert" *ngIf="noProduct">
                    <div class="img">
                        <img src="assets/images/noplat.png" width="145px" alt="">
                    </div>
                    <span>Aucun produit correspondant à votre recherche</span>
                </div>
            </div>
        </div>
        <router-outlet></router-outlet>
    </div>
</div>
<div id="total" *ngIf="total>0"></div>
<div class="btn-cart" (click)="displayP()" id="btncart" *ngIf="!siteClose">
    <img width="30px" src="assets/images/icons/basket.png">
    <div>{{elementsN}}</div>
</div>
<div #footer id="footer" class="footer display-footer" *ngIf="siteClose">
    <div *ngIf="siteClose" class="alert-msg">
        <div class="alert alert-danger text-center">
            {{siteCloseComment}}
        </div>
    </div>
</div>
<div *ngIf="displaypanier" class="omber"></div>
<div #basket class="basket" [class.animation]="displaypanier">
    <div class="head">
        <span class="span-h" *ngIf="displayProduct">Panier</span>
        <button class="btn-close" *ngIf="displayProduct" (click)="displayP()">
            <span></span>
            <span></span>
        </button>
    </div>
    <div [class.body]="displaypanier" id="style-4">
        <app-panier *ngIf="displayProduct" (closePanier)="closePanier()" [showButton]="true"></app-panier>
    </div>
    <button *ngIf="displaypanier" (click)="checkoutEvent()" class="btn btn-block btn-validate cursor-pointer">
        <span>VALIDER {{total | number : '1.2-2'}} €</span>
    </button>
</div>
<ng-template #template>
    <div class="modal-body text-center">
        <p>
            <i class="fa fa-exclamation-triangle fa-2 text-navy" aria-hidden="true"></i>
        </p>
        <p>Vous êtes sur le point de modifier le mode de votre commande.</p>
        <p>Si vous continuez, votre panier sera automatiquement vidé. Continuer ?</p>
        <button type="button" class="btn btn-default mr-10" (click)="confirm()">OUI</button>
        <button type="button" class="btn btn-primary" (click)="decline()">NON</button>
    </div>
</ng-template>
<ng-template #template2>
    <div class="modal-body text-center">
        <div class="alert alert-warning">
            <p>
                <i class="fa fa-exclamation-triangle fa-2 text-navy" aria-hidden="true"></i> Attention
            </p>
            <p>Montant minimum de livraison: {{amountMiniDelivery}} €, Voulez vous continue comme même?</p>
        </div>
        <button type="button" class="btn btn-default mr-10" (click)="confirm2()">OUI</button>
        <button type="button" class="btn btn-primary" (click)="decline2()">NON</button>
    </div>
</ng-template>